import React from 'react';
import FailedPayouts from '../../components/AdminNext/FailedPayouts';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };
  return {
    title: 'Failed payouts — Bas Recovery Admin',
    component: <HeadLessLayout><FailedPayouts /></HeadLessLayout>
  };
}

export default action;
